import tryGet from '../../utils/try-get'
import axios from 'axios'
const state = {
  shiftJobBroadcastSMSTemplate: {
    message: "New shift available: [[date]], [[starttime]] - [[endtime]], learn more [[joblink]]"
  },
  placementJobBroadcastSMSTemplate: {
    message:
      "Hi [[fname]].\n" +
      'There is a new opportunity available that may be of interest to you, to see all of the details please visit: {3}/job/{2}/{1}'
  },
  jobBookingCancelledFillerSMSTemplate: {
    message:
      "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}.\n{6}\n"
  },
  referenceCheckFormSMSTemplate: {
    message: `Hi {2} {3}\n` +
      'Please fill the form {4} to give us the reference check information about {0} {1}\n' +
      'Sincerely,\n{5}'
  },
  notifyClientOnBulkAssignSmsTemplate: {
    message: "Hi [[clientfname]]\n[[candidatefname]] [[candidatelname]] has been assigned to your service request(s) on [[jobdates]]"
  },
  notifyCandidateOnBulkAssignSmsTemplate: {
    message: "Hi [[candidatefname]]\nYou have been assigned to jobs on [[jobdates]]"
  },
  nannyAssignedEmployerNotificationSMSTemplate: {
    message:
      `Hello {1},\n` +
      `{2} {3} has been assigned to your service request on {0}.`
  },
  nannyAssignedCandidateNotificationSMSTemplate: {
    message:
      `Hello {1},\n` +
      `You have been assigned to a job on {0}.`
  },
  SMSTemplates: [],
  SMSTemplateErrors: [],
  statusChangeSMSTemplates: [],
  statusChangeSMSTemplatesErrors: [],
  listSmsTemplates: [],
  listIdNameSmsTemplates: []
};

const mutations = {
  setSMSTemplates(state, templates) {
    state.SMSTemplates = templates;
  },
  resetSMSTemplateErrors(state) {
    state.SMSTemplateErrors = []
  },
  loadStatusChangeSMSTemplate(state, templates) {
    state.statusChangeSMSTemplates = templates;
  },
  resetStatusChangeSMSTemplatesErrors(state) {
    state.statusChangeSMSTemplatesErrors = []
  },
  setListSmsTemplates(state, payload) {
    state.listSmsTemplates = payload;
  },
  setListIdNameSmsTemplates(state, payload) {
    state.listIdNameSmsTemplates = payload;
  },
};
const actions = {
  async getStatusChangeSMSTemplate({ commit, state, rootState }, SMSInfo) {
    await axios.get(
      `/api/smstemplates/?agency=${rootState.authentication.agencyID}&status=${encodeURIComponent(
        SMSInfo.status
      )}&type=${SMSInfo.type}&selector1=${SMSInfo.user}&deactivated=false`
    )
      .then(res => {
        commit("resetStatusChangeSMSTemplatesErrors");
        commit("loadStatusChangeSMSTemplate", res.data);
      })
      .catch(error => {
        state.statusChangeSMSTemplatesErrors.push(error);
      })
  },
  async getSMSTemplates({ commit, state, rootState }) {
    await axios.get(`/api/smstemplates/?agency=${rootState.authentication.agencyID}`)
      .then(res => {
        commit("resetSMSTemplateErrors");
        commit("setSMSTemplates", res.data);
      })
      .catch(error => {
        state.SMSTemplateErrors.push(error);
      })
  },
  setListSmsTemplates({ commit }, payload) {
    commit("setListSmsTemplates", payload);
  },
  setListIdNameSmsTemplates({ commit }, payload) {
    commit("setListIdNameSmsTemplates", payload);
  },
  getListSmsTemplates({ rootGetters, state, commit }) {
    return new Promise(async (resolve) => {
      if (state.listSmsTemplates && state.listSmsTemplates.length) {
        resolve(state.listSmsTemplates);
        return;
      }
      let res = await axios.get(
        `/api/smstemplates/?agency=${rootGetters.agencyID}`
      );
      if (res && res.data) {
        commit('setListSmsTemplates', res.data);
        resolve(res.data);
        return;
      }
      commit('setListSmsTemplates', []);
      resolve([]);
    });
  },
  getListIdNameSmsTemplates({ rootGetters, getters, commit }) {
    return new Promise(async (resolve) => {
      if (getters.listIdNameSmsTemplates && getters.listIdNameSmsTemplates.length) {
        resolve(getters.listIdNameSmsTemplates);
        return;
      }
      let res = await axios.get(
        `/api/smstemplates/?agency=${rootGetters.agencyID}&id_name=true`
      );
      if (res && res.data) {
        commit('setListIdNameSmsTemplates', res.data);
        resolve(res.data);
        return;
      }
      commit('setListIdNameSmsTemplates', []);
      resolve([]);
    });
  },
};

const getters = {
  shiftJobBroadcastSMSTemplate(state) {
    return state.shiftJobBroadcastSMSTemplate;
  },
  placementJobBroadcastSMSTemplate(state) {
    return state.placementJobBroadcastSMSTemplate;
  },
  jobBookingCancelledFillerSMSTemplate(state) {
    return state.jobBookingCancelledFillerSMSTemplate;
  },
  referenceCheckFormSMSTemplate(state) {
    return state.referenceCheckFormSMSTemplate;
  },
  notifyClientOnBulkAssignSmsTemplate(state) {
    return state.notifyClientOnBulkAssignSmsTemplate;
  },
  notifyCandidateOnBulkAssignSmsTemplate(state) {
    return state.notifyCandidateOnBulkAssignSmsTemplate;
  },
  nannyAssignedEmployerNotificationSMSTemplate(state) {
    return state.nannyAssignedEmployerNotificationSMSTemplate;
  },
  nannyAssignedCandidateNotificationSMSTemplate(state) {
    return state.nannyAssignedCandidateNotificationSMSTemplate;
  },
  SMSTemplates: state => tryGet(() => state.SMSTemplates) || [],
  SMSTemplateErrors: state => tryGet(() => state.SMSTemplateErrors) || [],
  statusChangeSMSTemplates: state => tryGet(() => state.statusChangeSMSTemplates) || [],
  statusChangeSMSTemplatesErrors: state => tryGet(() => state.statusChangeSMSTemplatesErrors) || [],
  listSmsTemplates(state) {
    return state.listSmsTemplates;
  },
  listIdNameSmsTemplates(state) {
    if (state.listSmsTemplates && state.listSmsTemplates.length) {
      return state.listSmsTemplates;
    }
    return state.listIdNameSmsTemplates;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/sms-template.js